export default __webpack_public_path__ + "static/media/habano-3Open.8999fe7b.jpg";